<template>
    <span class="message-square-plus-icon">
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            :stroke="stroke"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
            />
            <path d="M12 8v6" />
            <path d="M9 11h6" />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconMessageSquarePlus',
    props: {
        stroke: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>

<style scoped>
/* See IconPlayOutline.vue for why the wrapper needs to be a flex container
   itself: a plain <span> as a flex/grid item doesn't center its own
   inline-level svg content vertically. */
.message-square-plus-icon {
    display: inline-flex;
    align-items: center;
}
</style>
